import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  getTitle(): string {
    return "home";
  }

  constructor() { }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts